/**
 * Positional indexes for the admin tab strip in ``Admin.tsx``.
 *
 * ``RobotoStyledTabs`` keys by JSX position, so the index of each tab is
 * baked into the tab markup. Surfacing the indexes as named constants here
 * (rather than literals strewn across deep-link builders) makes them easy
 * to find, and keeps both ``Admin.tsx`` and any consumer (e.g.
 * ``ExploreChats/shareLinks.ts``) in lockstep without forming an import
 * cycle through ``Admin.tsx`` itself.
 *
 * Bump these whenever the tab order in ``Admin.tsx`` changes.
 */

export const ADMIN_EXPLORE_CHATS_TAB_INDEX = 10;
